// Surveyor Data
export const GET_SURVEYOR_DATA_REQUEST = "GET_SURVEYOR_DATA_REQUEST";
export const GET_SURVEYOR_DATA_SUCCESS = "GET_SURVEYOR_DATA_SUCCESS";
export const GET_SURVEYOR_DATA_FAILURE = "GET_SURVEYOR_DATA_FAILURE";

// Surveyor By ID
export const GET_SURVEYOR_BY_ID_REQUEST = "GET_SURVEYOR_BY_ID_REQUEST";
export const GET_SURVEYOR_BY_ID_SUCCESS = "GET_SURVEYOR_BY_ID_SUCCESS";
export const GET_SURVEYOR_BY_ID_FAILURE = "GET_SURVEYOR_BY_ID_FAILURE";

// Common Filter List
export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

// Surveyor App Info Data
export const GET_SURVEYOR_APP_INFO_DATA_REQUEST = "GET_SURVEYOR_APP_INFO_DATA_REQUEST";
export const GET_SURVEYOR_APP_INFO_DATA_SUCCESS = "GET_SURVEYOR_APP_INFO_DATA_SUCCESS";
export const GET_SURVEYOR_APP_INFO_DATA_FAILURE = "GET_SURVEYOR_APP_INFO_DATA_FAILURE";

// Surveyor App Project Data
export const GET_SURVEYOR_PROJECT_DATA_REQUEST = "GET_SURVEYOR_PROJECT_DATA_REQUEST";
export const GET_SURVEYOR_PROJECT_DATA_SUCCESS = "GET_SURVEYOR_PROJECT_DATA_SUCCESS";
export const GET_SURVEYOR_PROJECT_DATA_FAILURE = "GET_SURVEYOR_PROJECT_DATA_FAILURE";

export const UPDATE_SURVEYOR_ENTITY_PARAMS_SUCCESS = "UPDATE_SURVEYOR_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SURVEYOR_ENTITY_PARAMS_FAILURE = "UPDATE_SURVEYOR_ENTITY_PARAMS_FAILURE";

// Surveyor Project By ID
export const GET_SURVEYOR_PROJECT_BY_ID_REQUEST = "GET_SURVEYOR_PROJECT_BY_ID_REQUEST";
export const GET_SURVEYOR_PROJECT_BY_ID_SUCCESS = "GET_SURVEYOR_PROJECT_BY_ID_SUCCESS";
export const GET_SURVEYOR_PROJECT_BY_ID_FAILURE = "GET_SURVEYOR_PROJECT_BY_ID_FAILURE";

// Surveyor App Project History Data
export const GET_SURVEYOR_PROJECT_HISTORY_DATA_REQUEST = "GET_SURVEYOR_PROJECT_HISTORY_DATA_REQUEST";
export const GET_SURVEYOR_PROJECT_HISTORY_DATA_SUCCESS = "GET_SURVEYOR_PROJECT_HISTORY_DATA_SUCCESS";
export const GET_SURVEYOR_PROJECT_HISTORY_DATA_FAILURE = "GET_SURVEYOR_PROJECT_HISTORY_DATA_FAILURE";

export const UPDATE_SURVEYOR_HISTORY_ENTITY_PARAMS_SUCCESS = "UPDATE_SURVEYOR_HISTORY_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SURVEYOR_HISTORY_ENTITY_PARAMS_FAILURE = "UPDATE_SURVEYOR_HISTORY_ENTITY_PARAMS_FAILURE";

// Common Project History Filter List
export const GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_REQUEST = "GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_FAILURE = "GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_FAILURE";

// Surveyor Project History By ID
export const GET_SURVEYOR_PROJECT_HISTORY_BY_ID_REQUEST = "GET_SURVEYOR_PROJECT_HISTORY_BY_ID_REQUEST";
export const GET_SURVEYOR_PROJECT_HISTORY_BY_ID_SUCCESS = "GET_SURVEYOR_PROJECT_HISTORY_BY_ID_SUCCESS";
export const GET_SURVEYOR_PROJECT_HISTORY_BY_ID_FAILURE = "GET_SURVEYOR_PROJECT_HISTORY_BY_ID_FAILURE";

export const GET_SURVEYOR_TABLE_EXPORT_REQUEST = "GET_SURVEYOR_TABLE_EXPORT_REQUEST";
export const GET_SURVEYOR_TABLE_EXPORT_SUCCESS = "GET_SURVEYOR_TABLE_EXPORT_SUCCESS";
export const GET_SURVEYOR_TABLE_EXPORT_FAILURE = "GET_SURVEYOR_TABLE_EXPORT_FAILURE";

export const RESET_GET_REDUCER = "RESET_GET_REDUCER";

// Common Filter List
export const GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_REQUEST = "GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_FAILURE = "GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_FAILURE";

// Common Filter List
export const GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_REQUEST = "GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_FAILURE = "GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_FAILURE";

export const GET_SURVEYOR_APP_TABLE_EXPORT_REQUEST = "GET_SURVEYOR_APP_TABLE_EXPORT_REQUEST";
export const GET_SURVEYOR_APP_TABLE_EXPORT_SUCCESS = "GET_SURVEYOR_APP_TABLE_EXPORT_SUCCESS";
export const GET_SURVEYOR_APP_TABLE_EXPORT_FAILURE = "GET_SURVEYOR_APP_TABLE_EXPORT_FAILURE";

export const GET_SURVEYOR_PROJECT_TABLE_EXPORT_REQUEST = "GET_SURVEYOR_PROJECT_TABLE_EXPORT_REQUEST";
export const GET_SURVEYOR_PROJECT_TABLE_EXPORT_SUCCESS = "GET_SURVEYOR_PROJECT_TABLE_EXPORT_SUCCESS";
export const GET_SURVEYOR_PROJECT_TABLE_EXPORT_FAILURE = "GET_SURVEYOR_PROJECT_TABLE_EXPORT_FAILURE";
